import React from "react";
import { Checkbox, Select } from "antd";
import { toast } from "react-toastify";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import services from "../../../services";
import { withRouter } from "react-router-dom";
import FormleftNev from "../../common/FormleftNev";
import FormNavbar from "../../common/wizard_navbar";
import queryString from "query-string";
import Lang from "../../../lang";
import { Input } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import InstructionMessage from "../../VidimaModule/Modal/InstructionMessage";

const moment = require("moment");

const { Option } = Select;
// const dateFormat = 'DD-MM-YYYY';
const dateFormat = "YYYY-MM-DD";
const dateShowFormat = "dd/MMM/yyyy";
const InputFieldsAll = {
    PersonalDetails: [
        {
            key: "FullName",
            type: "text",
            display: Lang.langCheck.langRequest("Full Name"),
        },
        {
            key: "Email",
            type: "text",
            display: Lang.langCheck.langRequest("Email"),
        },
        {
            key: "DisplayName",
            type: "text",
            display: Lang.langCheck.langRequest("Display Name"),
        },
        {
            key: "status",
            type: "dropdown",
            display: "User Status",
            dropdownData: { 1: "ativo", 2: "inativo" },
        },
    ],
    Contatos: [
        {
            key: "Email",
            type: "text",
            display: "Email",
        },
        {
            key: "ContactNumber",
            type: "number",
            display: "Contact Number",
        },
    ],
    OtherDetails: [
        {
            key: "Password",
            type: "password",
            display: Lang.langCheck.langRequest("Password"),
        },
        {
            key: "Notes",
            type: "text",
            display: Lang.langCheck.langRequest("Notes"),
        },
        {
            key: "designation",
            type: "dropdown",
            display: Lang.langCheck.langRequest("Designation"),
        },
        {
            key: "DOB",
            type: "date",
            display: Lang.langCheck.langRequest("DOB"),
        },
    ],
    Grupo_de_Acesso: [],
};

const InputFields = [
    {
        key: "FullName",
        type: "text",
        display: "Full Name",
    },
    {
        key: "Email",
        type: "text",
        display: "Email",
    },
    {
        key: "DisplayName",
        type: "text",
        display: "Display Name",
    },
    {
        key: "ContactNumber",
        type: "number",
        display: "Contact Number",
    },
    {
        key: "Password",
        type: "password",
        display: "Password",
    },
    {
        key: "designation",
        type: "dropdown",
        display: "Designation",
    },
    {
        key: "Notes",
        type: "textarea",
        display: "Notes",
    },
    {
        key: "DOB",
        type: "date",
        display: "DOB",
    },
];

let count = 0;

class CreateUserComponent extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            FullName: "",
            Email: "",
            DisplayName: "",
            ContactNumber: "",
            Password: "",
            designation: "",
            Notes: "",
            DOB: null,
            isGroupAssign: false,
            AssignGroup: [],
            AssignGroupName: [],
            group_list: [],
            datePicker: "",
            desig_list: [],
            id: "",
            status: 1,
            isCreated: false,
            displayNameErrorMsg: "",
            FullNameErrorMsg: "",
            requiredField: {
                FullName: false,
                Email: false,
                DisplayName: false,
                Password: false,
                designation: false,
                status: false,
                AssignGroup: false,
            },
            changePassword: false,
            groupRemovePopup: "",
            showPopup: true,
        };
    }

    createInputs(nevkey) {
        let inputs = this.props.InputFieldsAll[nevkey].map((row, i) => {
            console.log("rrrrrrrrrrrrrrrrrrrrrrrrow", row);
            switch (row.type) {
                case "dropdown":
                    return row.dropdownData ? (
                        <div className="col-md-3">
                            <div className="input-box active-grey">
                                <span className="k-textbox-container k-state-empty w-100">
                                    <select
                                        type={row.type}
                                        className="form-control"
                                        onChange={this.handleChange}
                                        placeholder={row.display}
                                        value={this.state.status || ""}
                                        name={row.key}
                                    >
                                        <option selected value="">
                                            {Lang.langCheck.langRequest(
                                                row.display
                                            )}
                                        </option>
                                        {Object.keys(row.dropdownData).map(
                                            (key) => (
                                                <option value={key}>
                                                    {row.dropdownData[key]}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </span>
                                {this.state.requiredField[row.key] && (
                                    <span className="text-danger">
                                        Campo obrigatório
                                    </span>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="col-md-4">
                            <div className="input-box active-grey">
                                {/* <label className="input-label">{row.display}</label>  */}
                                <span className="k-textbox-container k-state-empty w-100">
                                    <select
                                        type={row.type}
                                        className="form-control"
                                        value={this.state[row.key] || ""}
                                        onChange={this.handleChange}
                                        placeholder={row.display}
                                        name={row.key}
                                    >
                                        <option selected value="">
                                            {Lang.langCheck.langRequest(
                                                "Select Designation"
                                            )}
                                        </option>
                                        {this.state.desig_list.map((_d, i) => (
                                            <option key={i} value={_d.id}>
                                                {_d.name}
                                            </option>
                                        ))}
                                    </select>
                                </span>
                                {this.state.requiredField[row.key] && (
                                    <span className="text-danger">
                                        Campo obrigatório
                                    </span>
                                )}
                            </div>
                        </div>
                    );
                    break;
                case "date":
                    return (
                        <div className="col-md-3">
                            <div className="input-box active-grey mb-0">
                                <span className="k-textbox-container k-state-empty">
                                    <label className="position-absolute date-input-css">
                                        Data de Nascimento
                                    </label>
                                    <DatePicker
                                        name="DOB"
                                        //format={dateFormat}
                                        max={new Date()}
                                        placeholder="Data de Nascimento"
                                        onChange={this.handleDate}
                                        className="form-control deadlineclender input-1"
                                        size="middle"
                                        label="Data de Nascimento"
                                        format={dateShowFormat}
                                        readOnly={true}
                                        value={
                                            (this.state.DOB &&
                                                new Date(this.state.DOB)) ||
                                            ""
                                        }
                                        style={{ width: "50%" }}
                                    />
                                    {/* {
                                        this.state.id ?
                                            this.state.datePicker
                                            :
                                            <DatePicker
                                                className="form-control"
                                                size="middle"
                                                name="DOB"
                                                format={dateFormat}
                                                disabledDate={this.disabledDate}
                                                placeholder="Data de Nascimento"
                                                onChange={this.handleDate}
                                            />
                                    } */}
                                </span>
                            </div>
                            {this.state.requiredField[row.key] && (
                                <span className="text-danger mt-0">
                                    Campo obrigatório
                                </span>
                            )}
                        </div>
                    );
                    break;
                case "textarea":
                    return (
                        <div className="col-md-12 mt-2">
                            <div className="input-box active-grey form-group">
                                <label className="input-label">
                                    {Lang.langCheck.langRequest(
                                        `${row.display}`
                                    )}
                                </label>
                                <textarea
                                    className="form-control heigh-auto input-1"
                                    name={row.key}
                                    type={row.type}
                                    style={{ width: "100%" }}
                                    onChange={this.handleChange}
                                    value={this.state[row.key] || ""}
                                />
                            </div>
                        </div>
                    );
                default:
                    return (
                        <div
                            className={
                                row.key === "FullName"
                                    ? "col-md-12"
                                    : row.key === "Email" ||
                                      row.key === "ContactNumber" ||
                                      (row.key === "Password" && this.state.id)
                                    ? "col-md-5"
                                    : row.key === "Username"
                                    ? "col-md-5"
                                    : "col-md-3"
                            }
                        >
                            <div className="input-box active-grey">
                                {/* <label className="input-label hidden">{row.display}</label>
                            <input type={row.type} className="input-1" value={this.state[row.key]} onChange={this.handleChange} placeholder={row.display} name={row.key}  />  */}
                                {row.key === "Email" &&
                                this.props &&
                                this.props.location &&
                                this.props.location.state &&
                                this.props.location.state.user_id ? (
                                    <Input
                                        name={row.key}
                                        type={row.type}
                                        readOnly
                                        autoComplete="new-field"
                                    
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        label={Lang.langCheck.langRequest(
                                            `${row.display}`
                                        )}
                                        value={this.state[row.key] || ""}
                                    />
                                ) : (
                                    <>
                                        {row.key === "Password" &&
                                        this.state.id ? (
                                            <>
                                                <div className="d-flex justify-content-around">
                                                    <Input
                                                        name={row.key}
                                                        type={row.type}
                                                        style={{ width: "80%" }}
                                                        className="input-1"
                                                        label={Lang.langCheck.langRequest(
                                                            `${row.display}`
                                                        )}
                                                        autoComplete="new-field"
                                                        onChange={
                                                            this.handleChange
                                                        }
                                                        value={
                                                            this.state[
                                                                row.key
                                                            ] || ""
                                                        }
                                                    />
                                                    <Button
                                                        ztyle={{ width: "50%" }}
                                                        className="align-self-center mt-3 ml-1 remove btn-ivdp-secondary cursor-pointer btn-xs"
                                                        primary={true}
                                                        onClick={
                                                            this.passwordHandler
                                                        }
                                                    >
                                                        Mudar Senha
                                                    </Button>
                                                </div>
                                            </>
                                        ) : (
                                            <Input
                                                readOnly={
                                                    row.key === "Username"
                                                }
                                                disabled={
                                                    row.key === "Username"
                                                }
                                                name={row.key}
                                                type={row.type}
                                                style={{ width: "100%" }}
                                                className="input-1"
                                                label={Lang.langCheck.langRequest(
                                                    `${row.display}`
                                                )}
                                                autoComplete="new-password"
                                                onChange={this.handleChange}
                                                value={
                                                    row.key === "Username"
                                                        ? this.state.Email
                                                        : this.state[row.key] ||
                                                          ""
                                                }
                                            />
                                        )}

                                        {/* {
                                                row.key === 'DisplayName' && this.state.DisplayName &&
                                                (
                                                    (this.state.DisplayName).includes(' ') ?
                                                        <span className="text-danger">espaço não permitido</span>
                                                    :
                                                    (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/).test(this.state.DisplayName) &&
                                                        <span className="text-danger">caractere especial não permitido</span>
                                                )
                                            } */}
                                        {this.state.requiredField[row.key] &&
                                            (row.key === "FullName" ? (
                                                <span className="text-danger">
                                                    {this.state
                                                        .FullNameErrorMsg ||
                                                        "Campo obrigatório"}
                                                </span>
                                            ) : row.key === "DisplayName" ? (
                                                <span className="text-danger">
                                                    {this.state
                                                        .displayNameErrorMsg ||
                                                        "Campo obrigatório"}
                                                </span>
                                            ) : (
                                                <span className="text-danger ml-2">
                                                    Campo obrigatório
                                                </span>
                                            ))}
                                    </>
                                )}
                            </div>
                        </div>
                    );
            }
        });
        return inputs;
    }

    passwordHandler = () => {
        let { changePassword } = this.state;
        let { Password } = this.state;
        Password = "";
        changePassword = true;
        this.setState({
            changePassword,
            Password,
        });
    };

    createInputFields = () => {
        let InputFieldsdivs = Object.keys(this.props.InputFieldsAll).map(
            (nevkey) => {
                return (
                    <div className="bg-white middle p20" id={nevkey}>
                        <div className="head">
                            <h2> {Lang.langCheck.langRequest(`${nevkey}`)}</h2>
                            <p className="font-14">
                                {/*"Lorem ipsum dolor sit amet, consetetur sadipscing elitrdiam"*/}
                            </p>
                        </div>
                        <div className="row">{this.createInputs(nevkey)}</div>
                    </div>
                );
            }
        );

        return InputFieldsdivs;
    };

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        //console.log(this.props)
        let parsed = queryString.parse(window.location.search);
        if (parsed.id) {
            this.setState(
                {
                    id: parsed.id,
                },
                () => {
                    this.getUserById(parsed.id);
                }
            );
        }
        this.getGroupList();
        this.getDesignationList();
        this.setgroupRemovePopup();
        if (parsed.id) {
            this.setState({
                showPopup: false,
                groupRemovePopup: null,
            });
        }
    }

    setgroupRemovePopup = () => {
        let groupRemovePopup = "";
        groupRemovePopup = (
            <div class="modal-content">
                <div class="modal-header popheader">
                    <span className="k-icon k-i-warning mt-1 k-icon-new-nivel2"></span>
                    <h5 class="modal-title mr-auto" id="ModalLabel">
                        {/* {`Pretende mesmo remover o ${
                        this.state.FullName ? this.state.FullName : `utilizador`
                    } dos grupos?`} */}
                        Pretende avançar sem adicionar o utilizador a qualquer
                        perfil?
                    </h5>
                </div>
                <div class="modal-footer popfooter justify-content-center">
                    <Button
                        type="button"
                        name="no"
                        class="k-primary btn-ivdp-secondary"
                        data-dismiss="modal"
                    >
                        Não
                    </Button>
                    <Button
                        type="button"
                        name="yes"
                        class="k-button k-primary btn-ivdp-primary"
                        data-dismiss="modal"
                        onClick={(e) => this.simhandler(e)}
                    >
                        Sim
                    </Button>
                </div>
            </div>
        );
        this.setState({
            groupRemovePopup,
        });
    };
    // componentDidUpdate(){
    //     services.lablecheck.setlable();
    // }

    handleDatePicker = () => {
        let datePicker = (
            <DatePicker
                className="form-control"
                size="middle"
                placeholder="Data de Nascimento"
                defaultValue={moment(`${this.state.DOB}`, dateFormat) || ""}
                disabledDate={this.disabledDate}
                format={dateFormat}
                onChange={this.handleDate}
            />
        );
        this.setState({
            datePicker,
        });
    };

    /*   Para desativar os dados de acordo com a condição */
    disabledDate = (current) => {
        // Can not select days before today and today
        return current && current.valueOf() > new Date();
    };

    getDesignationList = async () => {
        let data = {
            Filters: null,
            IsPagination: false,
            Page: 0,
            PageSize: 0,
            IsSortTypeDESC: false,
            SortBy: "",
        };
        let desig = await services.apiCall.requestApi(
            "/Designationlist/getall",
            data,
            "post"
        );
        if (desig) {
            this.setState({
                desig_list: desig,
            });
        }
    };

    getGroupList = async () => {
        let data = {
            Filters: null,
            IsPagination: false,
            Page: 0,
            PageSize: 0,
            IsSortTypeDESC: false,
            SortBy: "",
        };
        let grp = await services.apiCall.requestApi(
            "/Groups/AllGroups",
            data,
            "post"
        );
        if (grp) {
            // console.log("group",this.state.AssignGroup,grp)
            let { AssignGroup, AssignGroupName } = this.state;
            AssignGroup.map((id) => {
                grp.map((group) => {
                    if (group.id === id) {
                        AssignGroupName = [...AssignGroupName, group.groupName];
                    }
                });
            });
            this.setState({
                AssignGroupName,
                group_list: grp,
            });
        }
    };

    getUserById = async (id) => {
        let userDetail = await services.apiCall.requestApi(
            `/User/${encodeURIComponent(id)}`,
            {},
            "get"
        );
        //console.log(userDetail)
        if (userDetail) {
            this.setState(
                {
                    FullName: userDetail.fullName,
                    Email: userDetail.email,
                    DOB: userDetail.dob
                        ? moment(userDetail.dob).format(dateFormat) + ""
                        : "",
                    DisplayName: userDetail.displayName,
                    ContactNumber: userDetail.contactNumber,
                    Password:
                        "0x7CCEBE3E8550AE16ABBEA1BD8014F8DEE2BF5EFBA243682E86BF99873245980C5B570E97DBB9C1C31C2F82CA4110348736EB5266F76F278410F3EABF7B1FA1AE",
                    Notes: userDetail.notes,
                    designation: userDetail.designationid,
                    AssignGroup: userDetail.assignGroup,
                    isGroupAssign:
                        userDetail.assignGroup.length > 0 ? true : false,
                    status: userDetail.status === "Ativo" ? 1 : 2,
                },
                () => {
                    this.handleDatePicker();
                    this.checkRequiredField();
                }
            );
        }
    };

    checkRequiredField = () => {
        let { requiredField } = { ...this.state };
        Object.keys(requiredField).map((k) => {
            if (!this.state[k]) requiredField[k] = true;
        });

        this.setState({ requiredField });
    };

    handleDate = (e) => {
        let date = e.target.value || new Date();
        let { requiredField } = { ...this.state };
        // if(Object.keys(requiredField).includes('DOB')) requiredField['DOB'] = false
        this.setState({
            DOB: services.Converter.dateConvert(date, dateFormat),
            // requiredField
        });
    };

    handleChange = (e) => {
        let {
            requiredField,
            displayNameErrorMsg,
            FullNameErrorMsg,
            isCreated,
        } = { ...this.state };
        isCreated = false;
        var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        if (Object.keys(requiredField).includes(e.target.name))
            requiredField[e.target.name] = false;

        if (e.target.name === "DisplayName") {
            // if((e.target.value).includes(' ')){
            //     displayNameErrorMsg = "Espaço não permitido"
            //     requiredField[e.target.name] = true
            // }else if((/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/).test(e.target.value)){
            //     displayNameErrorMsg = "Contém caracteres inválidos"
            //     requiredField[e.target.name] = true
            // }else{
            //     displayNameErrorMsg = "Campo obrigatório"
            //     requiredField[e.target.name] = false
            // }
        }
        if (e.target.name === "FullName") {
            // if((e.target.value).includes(' ')){
            //     FullNameErrorMsg = "Espaço não permitido"
            //     requiredField[e.target.name] = true
            // }
            // else if((/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/).test(e.target.value)){
            //     FullNameErrorMsg = "Contém caracteres inválidos"
            //     requiredField[e.target.name] = true
            // }else{
            //     FullNameErrorMsg = "Campo obrigatório"
            //     requiredField[e.target.name] = false
            // }
        }
        if (e.target.name === "Password") {
            if (
                !this.state.changePassword &&
                this.props &&
                this.props.location &&
                this.props.location.state &&
                this.props.location.state.user_id
            ) {
                return;
            }
        }
        this.setState({
            [e.target.name]: e.target.value,
            requiredField,
            displayNameErrorMsg,
            FullNameErrorMsg,
            isCreated,
        });
        //console.log('aaaaaaaa',e.target.name)
    };

    handleCheck = (e) => {
        let { requiredField } = { ...this.state };
        if (e.target.checked) requiredField["AssignGroup"] = false;
        else delete requiredField["AssignGroup"];
        if (this.state.id) {
            this.setgroupRemovePopup();
        }

        this.setState(
            {
                isGroupAssign: e.target.checked,
                requiredField,
            },
            () => {
                let { isGroupAssign, showPopup } = this.state;
                if (isGroupAssign) {
                    showPopup = false;
                } else {
                    showPopup = true;
                }
                this.setState({
                    showPopup,
                });
            }
        );
    };

    simhandler = () => {
        if (this.checkRequestData()) {
            if (this.state.id) {
                this.handleUpdateUser(this.state.backUrl);
            } else {
                this.handleCreateUser(this.state.backUrl);
            }
        } else {
            return;
            // toast.error('Por favor preencha todos os campos')
        }
    };

    handleSelect = (e) => {
        console.log("Select", e);
        let { requiredField, group_list } = { ...this.state };
        if (Object.keys(requiredField).includes("AssignGroup"))
            requiredField["AssignGroup"] = false;
        // console.log("valueeeee",e)\
        let key;
        group_list.map((group) => {
            if (group.id === e.lastItem) key = group.groupName;
        });
        this.setState(
            {
                AssignGroup: e,
                requiredField,
                AssignGroupName: [...this.state.AssignGroupName, key],
            },
            () => {}
        );
    };

    checkRequestData = () => {
        let data = { ...this.state };
        let { requiredField } = this.state;
        let cond = true;
        // console.log("llllllllllllllllllll",data)
        if (!data["isGroupAssign"]) {
            delete data["AssignGroup"];
            delete data["isGroupAssign"];
        } else {
            if (data["AssignGroup"].length === 0) data["AssignGroup"] = "";
            // delete data['isGroupAssign']
        }
        // console.log("ddddddddddddddddddddd",data)
        delete data["desig_list"];
        delete data["group_list"];

        Object.keys(data).map((_k) => {
            if (!data[_k] && Object.keys(requiredField).includes(_k)) {
                cond = false;
                requiredField[_k] = true;
            }
            if (requiredField["DisplayName"]) {
                cond = false;
            }
        });
        let { AssignGroup, isGroupAssign } = this.state;
        if (AssignGroup.length < 1 && isGroupAssign) {
            requiredField["AssignGroup"] = true;
        }

        this.setState({ requiredField });
        // console.log("....count",count)

        return cond;

        // Object.keys(data).map(_k => {
        //     if(data[_k]){
        //         count++;
        //     }
        // })
    };

    handleSubmit = (e, backUrl) => {
        e.preventDefault();
        let { showPopup, isCreated } = this.state;
        if (showPopup && !isCreated) {
            this.setState({
                backUrl,
            });
            return;
        }
        if (this.checkRequestData()) {
            if (this.state.id) {
                this.handleUpdateUser(backUrl);
            } else {
                this.handleCreateUser(backUrl);
            }
        } else {
            return;
            // toast.error('Por favor preencha todos os campos')
        }
    };

    handleUpdateUser = async (backUrl) => {
        let data = {};
        data = {
            id: this.state.id,
            FullName: this.state.FullName,
            Email: this.state.Email,
            DisplayName: this.state.DisplayName,
            Password: this.state.Password,
            ContactNumber: this.state.ContactNumber,
            DesignationId: Number(this.state.designation),
            DOB: this.state.DOB || null,
            status: parseInt(this.state.status),
        };
        if (this.state.Notes) data["Notes"] = this.state.Notes;
        if (this.state.isGroupAssign && this.state.AssignGroup.length > 0)
            data["AssignGroup"] = this.state.AssignGroup;
        if (!this.state.isGroupAssign) data["AssignGroup"] = [];

        let res = await services.apiCall.requestApi(
            `/User/Create/${encodeURIComponent(data.id)}`,
            data,
            "post"
        );
        console.log("handleUpdateUser", res);
        if (res) {
            if (res.success === "Sim") {
                toast.success(
                    `O utilizador ${this.state.FullName} foi atualizado com sucesso`
                );
            }

            if (backUrl) {
                this.props.history.push({
                    pathname: backUrl,
                    state: { topBarMenu: this.props.topBarMenuOption },
                });
            }
        }
    };

    handleCreateUser = async (backUrl) => {
        let data = {};
        data = {
            id: this.state.id,
            FullName: this.state.FullName,
            Email: this.state.Email,
            DisplayName: this.state.DisplayName,
            Password: this.state.Password,
            ContactNumber: this.state.ContactNumber,
            DesignationId: Number(this.state.designation),
            DOB: this.state.DOB || null,
            status: parseInt(this.state.status),
        };

        if (this.state.Notes) data["Notes"] = this.state.Notes;
        if (this.state.isGroupAssign && this.state.AssignGroup.length > 0)
            data["AssignGroup"] = this.state.AssignGroup;
        if (!this.state.isGroupAssign) data["AssignGroup"] = [];

        //console.log('handleCreateUser')
        if (!this.state.isCreated || !backUrl) {
            let res = await services.apiCall.requestApi(
                `/User/Create/""`,
                data,
                "post"
            );
            if (res) {
                toast.success("usuário criado com sucesso");
                this.setState({
                    isCreated: true,
                });
                if (!backUrl) this.handleRoute({ id: res });
            }
            // console.log(".................pppppppppp",res)
        }
        if (backUrl && this.state.isCreated) {
            this.props.history.push({
                pathname: backUrl,
                state: { topBarMenu: this.props.topBarMenuOption },
            });
        }
    };

    handleRoute = (row) => {
        this.props.history.push({
            pathname: "/create_user",
            search: "?id=" + encodeURIComponent(row.detalheURL),
            state: { user_id: row.id, topBarMenu: this.props.topBarMenuOption },
        });

        window.location.reload();
    };
    /*  Para renderizar o conteúdo html da página   */

    render() {
        // console.log("props-----------", this.props)
        const message =
            "Caso o utilizador não esteja adicionado a perfis, este não possuirá permissões de acesso a qualquer operação na plataforma do IVDP";
        return (
            <div className="dashboard">
                {this.state.id ? (
                    <FormNavbar
                        to={"/user_list"}
                        topBarMenu={this.props.topBarMenuOption}
                        handleSubmit={(e, url) => this.handleSubmit(e, url)}
                        type="user"
                        headName="Edit User"
                        parentName="Utilizador"
                    />
                ) : (
                    <FormNavbar
                        to={"/user_list"}
                        topBarMenu={this.props.topBarMenuOption}
                        handleSubmit={(e, url) => this.handleSubmit(e, url)}
                        type="user"
                        headName="Create New User"
                        parentName="Utilizador"
                    />
                )}
                <div className="full-container edit-ward">
                    <FormleftNev InputFieldsAll={InputFieldsAll} />
                    <div className="right-section">
                        <div className="row top-serch">
                            {this.createInputFields()}
                            {/* <div className="col-md-3">
                    <div className="form-group ">
                        <input type="text" name="FullName" value={this.state.FullName} onChange={this.handleChange}  className="form-control" placeholder="Full Name" />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group ">
                    <input type="text" className="form-control" name="DisplayName" value={this.state.DisplayName} onChange={this.handleChange} placeholder="Display Name" />
                </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group ">
                    <input type="number" className="form-control" name="ContactNumber" value={this.state.ContactNumber} onChange={this.handleChange} placeholder="Contact Number" />
                </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group ">
                    <input type="text" className="form-control" name="Email" value={this.state.Email} onChange={this.handleChange} placeholder="Email" />
                </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group ">
                    <input type="Password" className="form-control" name="Password" value={this.state.Password} onChange={this.handleChange} placeholder="Password" />
                </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group ">
                    <select type="number" className="form-control" name="designation" value={this.state.designation} onChange={this.handleChange}>
                        <option selected value="">Select Designation</option>
                        {
                            this.state.desig_list.map((_d,i)=>(
                                <option key={i} value={_d.id}>{_d.name}</option>
                            ))
                        }
                    </select>
                </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group calender-field position-relative">
                    <div>
                    { 
                        this.props && this.props.location && this.props.location.state && this.props.location.state.user_id ? 
                            this.state.datePicker
                        :
                        <DatePicker 
                            className="form-control"
                            size="middle"
                            name="DOB"
                            format={dateFormat}
                            placeholder="Date of Birth"
                            onChange={this.handleDate}
                        />
                    }
                    </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group ">
                    <input type="text" className="form-control" name="Notes" value={this.state.Notes} onChange={this.handleChange} placeholder="Notes" />
                </div>
                </div>  */}

                            <div
                                className="bg-white middle p20"
                                id="Grupo_de_Acesso"
                            >
                                <div className="head">
                                    <h2>Atribuir Perfil</h2>
                                    <p className="font-14"></p>
                                </div>
                                <div className="row">
                                    <InstructionMessage
                                        message={message}
                                        messageFor="nivel"
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <div className="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    checked={
                                                        this.state.isGroupAssign
                                                    }
                                                    onChange={this.handleCheck}
                                                    id="customCheck1"
                                                    name="example1"
                                                />
                                                <label
                                                    className="custom-control-label"
                                                    htmlFor="customCheck1"
                                                >
                                                    {Lang.langCheck.langRequest(
                                                        "Assign Group"
                                                    )}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.isGroupAssign && (
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <Select
                                                    showSearch
                                                    mode="multiple"
                                                    className="form-control"
                                                    placeholder={Lang.langCheck.langRequest(
                                                        "Select Group"
                                                    )}
                                                    value={
                                                        this.state.AssignGroup
                                                    }
                                                    onChange={this.handleSelect}
                                                    optionFilterProp="children"
                                                >
                                                    {this.state.group_list.map(
                                                        (_list, index) =>
                                                            _list.status ===
                                                                "Ativo" && (
                                                                <Option
                                                                    key={index}
                                                                    value={
                                                                        _list.id
                                                                    }
                                                                >
                                                                    {
                                                                        _list.groupName
                                                                    }
                                                                </Option>
                                                            )
                                                    )}
                                                </Select>
                                                {this.state.requiredField[
                                                    "AssignGroup"
                                                ] && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* <div className="row">
                <div className="col-md-12 text-center">
                    {
                        (this.props && this.props.location && this.props.location.state && this.props.location.state.user_id) ?
                        <button type="button" onClick={this.handleUpdateUser} className="btn btn-theme mr-4">UPDATE USER</button>
                        :
                        <button type="button" onClick={this.handleCreateUser} className="btn btn-theme mr-4">CREATE USER</button>
                    }
                </div>
                </div>  */}
                    </div>
                    {this.state.showPopup && !this.state.isCreated && (
                        <div className="modal center" id="groupPopup">
                            <div class="modal-dialog modal-dialog-centered">
                                {this.state.groupRemovePopup}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(CreateUserComponent);
